import { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';

export type IAvailableFilter = {
  Exhibitor: '';
  Buyer: '';
  Seller: '';
  Both: '';
};

const SlotsCompanyFilter = ({
  onChange,
}: {
  onChange?: (value: IAvailableFilter) => void;
}) => {
  const [selectedRoles, setSelectedRoles] = useState<IAvailableFilter>({
    Exhibitor: '',
    Buyer: '',
    Seller: '',
    Both: '',
  });

  const handleChange = (event: any) => {
    const { name, checked } = event.target;
    setSelectedRoles((prev) => ({
      ...prev,
      [name]: checked ? name : '',
    }));
  };

  useEffect(() => {
    if (selectedRoles) {
      onChange?.(selectedRoles);
    }
  }, [selectedRoles]);

  return (
    <>
      <Row className='align-items-center h-100'>
        {Object.keys(selectedRoles).map((role) => (
          <Col
            key={role}
            xs={6}
            md={3}
            className='d-flex justify-content-center align-items-center'
          >
            <Form.Check
              type='checkbox'
              label={role}
              name={role}
              // checked={selectedRoles[role]}
              onChange={handleChange}
            />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default SlotsCompanyFilter;
